
import { Check, X } from "lucide-react";

export const ComparisonSection = () => {
  const comparisonData = [
    {
      feature: "24/7 Monitoring & Support",
      traditional: false,
      edgefi: true,
      note: "Sleep soundly knowing your systems are watched around the clock, not just during business hours when problems often happen after everyone has gone home."
    },
    {
      feature: "Proactive Problem Prevention",
      traditional: false,
      edgefi: true,
      note: "Your issues are resolved before they impact your team or customers, not after they've already caused downtime and frustration."
    },
    {
      feature: "Predictable Monthly Costs",
      traditional: false,
      edgefi: true,
      note: "Plan your budget with confidence thanks to fixed monthly fees, eliminating those surprise expenses that disrupt your financial planning."
    },
    {
      feature: "Strategic Technology Roadmap",
      traditional: false,
      edgefi: true,
      note: "Your technology evolves alongside your business goals with forward-looking plans that anticipate your future needs, not just quick fixes."
    },
    {
      feature: "Comprehensive Security",
      traditional: false,
      edgefi: true,
      note: "Your business is protected by multiple layers of security included as standard, not offered as expensive afterthoughts when it's too late."
    },
    {
      feature: "Business-Focused Reviews",
      traditional: false,
      edgefi: true,
      note: "You receive regular reviews focused on how technology is supporting your business goals, not just technical metrics."
    },
  ];

  return (
    <section className="py-16 bg-edgefi-white" id="comparison">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-edgefi-purple/10 text-edgefi-purple rounded-full text-sm font-medium mb-4">A Better Experience</span>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            The IT Support Your Business Deserves
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            See how your technology experience transforms compared to traditional break-fix IT support.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto overflow-hidden rounded-xl border border-gray-200 shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="py-6 px-6 text-left text-sm font-semibold text-gray-900 w-1/2">
                  What Your Business Needs
                </th>
                <th scope="col" className="py-6 px-3 text-center text-sm font-semibold text-gray-600">
                  Traditional IT
                </th>
                <th scope="col" className="py-6 px-3 text-center text-sm font-semibold text-edgefi-purple">
                  edgefi Managed Services
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {comparisonData.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900">
                    {item.feature}
                    <p className="text-xs text-gray-500 mt-1">{item.note}</p>
                  </td>
                  <td className="py-4 px-3 text-center">
                    {item.traditional ? (
                      <Check className="h-5 w-5 text-green-500 mx-auto" />
                    ) : (
                      <X className="h-5 w-5 text-red-500 mx-auto" />
                    )}
                  </td>
                  <td className="py-4 px-3 text-center">
                    {item.edgefi ? (
                      <div className="bg-edgefi-purple/10 rounded-full p-1 inline-flex">
                        <Check className="h-5 w-5 text-edgefi-purple mx-auto" />
                      </div>
                    ) : (
                      <X className="h-5 w-5 text-red-500 mx-auto" />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
